import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function EmailVerification() {
  const location = useLocation();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_AUTH;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) return;

    fetch(`${API_BASE_URL}/Auth/verify-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        Email: "",
        token 
      }),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Email verification failed");
        const data = await res.json();
         

        navigate("/login");
      })
      .catch((err) => {
        console.error(err);
        alert("Invalid or expired verification link");
      });
  }, [location, navigate]);

  return <p>Verifying your email...</p>;
}

export default EmailVerification;
